import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'
import { baseUrl } from '../../config/config_dev'

export const picUrl = baseUrl + 'v1/filestore/uploadfile' // 图片接口

export const login = option =>
  request3('v1/vendorstaff/login', option, false, false) // 登录

export const logout = option =>
  request3('v1/vendorstaff/logout', option, true, false) // 登出

export const getacategorys = option =>
  request3('v1/category/getacategorys', option, true, false) // 产品分类1级

export const getbcategorys = option =>
  request3('v1/category/getbcategorys', option, true, false) // 产品分类2级

export const getccategorys = option =>
  request3('v1/category/getccategorys', option, true, false) // 产品分类3级

export const deletefile = option => {
  const urls = urlStringify(option)
  return request3('v1/filestore/deletefile' + urls, {}, true, false)
} // 删除图片

export const uploadfile = option =>
  request3('v1/filestore/uploadfile', option, true, true) // 上传图片

export default {
  // 图片接口
  picServerUrl: baseUrl + 'v1/filestore/uploadfile',
  qrcode: baseUrl + 'v1/wxapp3party/getqrcode',
  getqrcodepic: baseUrl + 'v1/common/getqrcode',
  getwxacode: baseUrl + 'v1/wxapp3party/getwxacode',
  // 登录
  login: option => request3('v1/vendorstaff/login', option, false),
  // 登录
  syslogin: option => request3('v1/sysstaff/login', option, false),
  // 登出
  logout: option => request3('v1/vendorstaff/logout', option, true),
  // 登出
  syslogout: option => request3('v1/sysstaff/logout', option, true),
  // 上传图片
  uploadfile: option => request3('v1/filestore/uploadfile', option, true, true),
  // 获取企业信息
  getvendor: option => {
    const urls = urlStringify(option)
    return request3('v1/vendor/getvendor' + urls, {}, true)
  },
  // 修改密码
  modifypassword: option =>
    request3('v1/vendorstaff/modifypassword', option, true),
  // 更新企业信息
  updatevendor: option => request3('v1/vendor/updatevendor', option, true),
  // 新增企业信息
  addvendor: option => request3('v1/vendor/addvendor', option, true),
  // v1/vendor/getzsvendors
  getzsvendors: option => request3('v1/vendor/getzsvendors', option, true),
  //  查询所有的物流公司列表
  getallexpresses: option =>
    request3('v1/logistics/getallexpresses', option, true),
  //  查询所有的物流公司列表
  getexpresses: option => request3('v1/logistics/getexpresses', option, true),
  //  商家设置快递公司
  setvendorexpress: option =>
    request3('v1/logistics/setvendorexpress', option, true),
  // 获取企业信息
  setvendoradminuser: option => {
    const urls = urlStringify(option)
    return request3('v1/vendor/setvendoradminuser' + urls, {}, true)
  },
  // 获取企业信息
  setpoints2cashratio: option => {
    const urls = urlStringify(option)
    return request3('v1/vendor/setpoints2cashratio' + urls, {}, true)
  }

}
